export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar la compra, recibirás acceso digital a los documentos: un email con el enlace para descargar los 12 PDF (6 tomos + 6 bonos) en tu computadora, tablet o teléfono. No se realizan envíos físicos. Acceso de por vida, sin suscripción.'
  },
  {
    q: '¿Puedo comprar Enciclopedia Pilates 360 desde cualquier país?',
    a: 'Sí. El contenido está en español y, al tratarse de material digital, puedes utilizarlo desde cualquier país donde nuestra plataforma permita completar la compra.'
  },
  {
    q: '¿Puedo utilizarlo si enseño Pilates en Latinoamérica o España?',
    a: 'Sí. Los ejercicios y recursos se basan en el método Pilates y puedes utilizarlos como material de consulta para preparar y adaptar tus clases, independientemente del país donde trabajes.'
  },
  {
    q: '¿Sirve si soy instructora nueva o si tengo experiencia?',
    a: 'Sirve para ambas. Si eres nueva, los tomos te dan la estructura que te falta. Si tienes experiencia, los bonos te hacen más eficiente en la preparación. El 40% de nuestras usuarias son instructoras nuevas. El 60% son experimentadas que quieren mejorar.'
  },
  {
    q: '¿Qué incluye exactamente el pack completo por 17,99€?',
    a: '6 Tomos + 6 Bonos: 240 fichas visuales, 51 clases estructuradas (48 en los tomos y 3 adicionales en el Bono 1) y 515 páginas en PDF, con plantillas imprimibles. Recibirás 12 PDF descargables mediante el enlace que te llega por email tras el pago. Sin suscripción. Acceso de por vida.'
  },
  {
    q: '¿Qué diferencia hay con otros materiales de Pilates que ya existen?',
    a: 'Cada ficha tiene correcciones exactas y cues listos, incluye un sistema completo de planificación, está diseñado por instructoras experimentadas — no por "expertos" que no enseñan — tiene garantía de 7 días y el 98% de quienes lo compran se queda.'
  },
  {
    q: '¿Puedo utilizarlo si trabajo con alumnos de diferentes niveles?',
    a: 'Sí. Incluye variantes, progresiones y regresiones para ayudarte a seleccionar opciones adecuadas, siempre aplicando tu criterio profesional.'
  },
  {
    q: '¿Vale la pena si ya planifico bien mis clases?',
    a: 'Probablemente sí. Incluso instructoras que planifican bien ahorran de 5 a 8 horas semanales con esto. Además, los bonos (Cues, Correcciones, Seguridad) son herramientas que la mayoría no tiene.'
  },
  {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito (Visa, Mastercard, American Express). El precio está en euros (EUR) y el checkout convierte el cobro automáticamente a la moneda de tu país. El pago es seguro y no tiene comisiones ocultas.'
  },
  {
    q: '¿Sirve para dar clases online?',
    a: 'Totalmente. Muchas instructoras usan esto para clases online, presenciales e híbridas. El Bono del Planner te ayuda a organizar ambos formatos.'
  },
  {
    q: '¿Incluye vídeos?',
    a: 'No. Es una colección de documentos PDF con ejercicios, indicaciones, correcciones y otros recursos profesionales.'
  },
  {
    q: '¿Funciona para adultos mayores, embarazadas o lesiones?',
    a: 'Sí. El Tomo 6 está completamente dedicado a poblaciones especiales: embarazo, post-parto, tercera edad, hernias, escoliosis, osteoporosis y más. Es el tomo más completo en materia de seguridad.'
  }
];
